import React, { FC } from 'react';

import { IconProps } from 'types/components';

import CardIcon from './CardIcon';

const JsbCard: FC<IconProps> = (props) => (
  <CardIcon {...props}>
    <rect width="208" height="134" x="1" y="1" fill="#e7ebfa" rx="24" />
    <path fill="#d6dce5" d="M185 136H25a25 25 0 0 1-25-25V25A25 25 0 0 1 25 0h160a25 25 0 0 1 25 25v86a25 25 0 0 1-25 25ZM25 1A24 24 0 0 0 1 25v86a24 24 0 0 0 24 24h160a24 24 0 0 0 24-24V25a24 24 0 0 0-24-24Z" />
    <path fill="#fff" d="M155.49 92.42a16 16 0 0 1-16 16h-87V45.09a16 16 0 0 1 16-16h87Z" />
    <path fill="url(#a)" d="M173 54.45a11.46 11.46 0 0 0-11.46 11.46V77.8h16.18a5.76 5.76 0 0 1 1.13.07c3.65.19 6.36 2.07 6.36 5.35 0 2.58-1.83 4.78-5.23 5.22v.13c3.72.25 6.55 2.33 6.55 5.54 0 3.46-3.15 5.72-7.3 5.72H161.5v23.29h16.8a11.46 11.46 0 0 0 11.46-11.45V54.45Z" transform="translate(-40 -20)" />
    <path fill="url(#b)" d="M167.16 96.18H174.59a2.94 2.94 0 0 0 2.33-3 3.06 3.06 0 0 0-2.33-3 3.51 3.51 0 0 0-.82-.06h-6.61Z" transform="translate(-40 -20)" />
    <path fill="url(#c)" d="M173.77 81.26a2.74 2.74 0 0 1 0 5.42 1.83 1.83 0 0 1-.63.06h-6V81.2h6a2.73 2.73 0 0 1 .38 0 1.29 1.29 0 0 0 .25.06Z" transform="translate(-40 -20)" />
    <path fill="url(#d)" d="M109.7 54.45a11.46 11.46 0 0 0-11.46 11.46v28.26a22.71 22.71 0 0 0 9.88 2.58c4 0 6.11-2.39 6.11-5.67V77.74h9.82V91c0 5.16-3.21 9.38-14.1 9.38A48.23 48.23 0 0 1 98.18 99v24.11H115a11.46 11.46 0 0 0 11.46-11.46v-57.2Z" transform="translate(-40 -20)" />
    <path fill="url(#e)" d="M141.36 54.45a11.46 11.46 0 0 0-11.46 11.46v15c2.9-2.46 7.93-4 16-3.65a51.47 51.47 0 0 1 9 1.38v4.85a21.71 21.71 0 0 0-8.63-2.49c-6.17-.44-9.89 2.58-9.89 7.87s3.72 8.37 9.89 7.87a23.08 23.08 0 0 0 8.73-2.57V99a49.64 49.64 0 0 1-9 1.39c-8.12.38-13.15-1.2-16-3.65v26.44h16.81a11.46 11.46 0 0 0 11.45-11.46V54.45Z" transform="translate(-40 -20)" />
    <defs>
      <linearGradient id="a" x1="161.55" x2="189.81" y1="129.21" y2="129.21" gradientTransform="matrix(1 0 0 -1 0 218)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#007940" />
        <stop offset=".23" stopColor="#00873f" />
        <stop offset=".74" stopColor="#40a737" />
        <stop offset="1" stopColor="#5cb531" />
      </linearGradient>
      <linearGradient href="#a" id="b" x1="161.55" x2="189.84" y1="124.84" y2="124.84" />
      <linearGradient href="#a" id="c" x1="161.55" x2="189.84" y1="134.03" y2="134.03" />
      <linearGradient id="d" x1="98.23" x2="126.95" y1="129.24" y2="129.24" gradientTransform="matrix(1 0 0 -1 0 218)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#1f286f" />
        <stop offset=".47" stopColor="#004e94" />
        <stop offset=".83" stopColor="#0066b1" />
        <stop offset="1" stopColor="#006fbc" />
      </linearGradient>
      <linearGradient id="e" x1="129.74" x2="157.63" y1="129.18" y2="129.18" gradientTransform="matrix(1 0 0 -1 0 218)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#6c2c2f" />
        <stop offset=".17" stopColor="#882730" />
        <stop offset=".57" stopColor="#be1833" />
        <stop offset=".86" stopColor="#dc0436" />
        <stop offset="1" stopColor="#e60039" />
      </linearGradient>
    </defs>
  </CardIcon>
);

export default JsbCard;
